'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var bases = require('./util/bases.js');

function fromString(string) {
  var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf8';
  var base = bases[encoding];

  if (!base) {
    throw new Error("Unsupported encoding \"".concat(encoding, "\""));
  }

  return base.decoder.decode("".concat(base.prefix).concat(string));
}

exports.fromString = fromString;